var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgUser = function SvgUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.1 33.5c4.2-3.1 7.2-8.1 7.2-13.7C49.1 10.9 41.6 3 32 3c-9.4 0-17.2 7.4-17.2 16.9 0 5.6 2.9 10.8 7.2 13.9C11.8 37.3 4.8 47.3 4.8 58.6 4.8 60 6 61 7.3 61c1.5 0 2.4-1.3 2.4-2.4-.2-12.1 9.8-21.8 22.1-21.8h.4c12.4 0 22.1 9.7 22.1 21.8 0 1.5 1.3 2.4 2.4 2.4 1.5 0 2.4-1.3 2.4-2.4.7-11.5-6.6-21.3-17-25.1zm-22-13.6c0-6.6 5.4-11.8 11.9-11.8s11.9 5.3 11.9 11.8S38.5 32 32 32s-11.9-5.6-11.9-12.1z",
    fill: "currentColor"
  })));
};
export default SvgUser;